import { Rule } from 'antd/lib/form';
import FormSelect from 'components/Select/FormSelect';
import SelectedItem from 'components/SelectedItem/SelectedItem';
import React, { useCallback, useMemo } from 'react';
import { TYandexPaymentType } from 'types';
import { yandexPaymentTypes } from 'appConstants';
import { useTranslation } from 'react-i18next';
import style from './YandexPaymentTypeSelect.module.scss';

interface IYandexPaymentTypeSelect {
	settingsId: string;
	selectedYandexPaymentTypes: TYandexPaymentType[];
	onChange: (value: TYandexPaymentType[]) => void;
}

const YandexPaymentTypeSelect: React.FC<IYandexPaymentTypeSelect> = ({
	onChange,
	settingsId,
	selectedYandexPaymentTypes,
}) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectPaymentType') }], [t]);

	const handleRemove = useCallback(
		(id: string) => {
			const updatedSelectedItems = selectedYandexPaymentTypes.filter((el) => el !== id);
			onChange(updatedSelectedItems);
		},
		[selectedYandexPaymentTypes, onChange],
	);

	return (
		<>
			<FormSelect
				testId="YandexPaymentTypeSelect"
				label="yandexPaymentTypeLabel"
				mode="multiple"
				name={`yandexPaymentType-${settingsId}`}
				options={yandexPaymentTypes}
				onChange={onChange}
				counterValue={selectedYandexPaymentTypes.length}
				validationRules={validationRules}
			/>
			<div className={style.selectedTypesList}>
				{selectedYandexPaymentTypes.map((el) => (
					<SelectedItem key={el} label={el} onDelete={() => handleRemove(el)} />
				))}
			</div>
		</>
	);
};

export default React.memo(YandexPaymentTypeSelect);
